<script lang="ts">
    import src from './Icons/svg/cancel_nocircle_FILL0_wght400_GRAD0_opsz24.svg';
    import WhiteColor from './WhiteColor.svelte';

    export let disabled: boolean = false;
    export let showIcon: boolean = true;
    export let title: string = '';
    export let opacity: number = 1;
</script>

<button class="btn-main dont-break" class:showIcon on:click {disabled} {title} style="opacity: {opacity}">
    <span
        style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(152deg) brightness(103%) contrast(103%); width:24px; height: 24px;"
    >
        <img {src} alt="Add" class:showIcon style="position: relative; top: 1px;" />
    </span>
</button>

<style>
    .btn-main {
        background-color: #000;
        color: white;
        border: none;
        cursor: pointer;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        line-height: 14px;
    }
    .btn-main img {
        height: 23px;
        width: 23px;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
